import { flex, opacityEffect } from "../styles/utils";
import styled from "styled-components";

export const FormContainer = styled.div<{
  $backgroundColor: string;
  $innerPadding: string;
}>`
  ${flex("column")}
  align-items: stretch;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: auto;

  background: ${(props) => props.$backgroundColor || " #cecece"};

  padding: ${(props) => props.$innerPadding || "1rem"};

  /* Hide scrollbars for WebKit browsers */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbars for Firefox */
  scrollbar-width: none;

  box-sizing: border-box;
  height: 100%;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 0.75rem;

  button {
    ${opacityEffect}
    color: var(--black);
    font-weight: 600;
    border: none;
    border-radius: 8px;
    width: 60%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const Form = styled.form<{ $textColor: string }>`
  label {
    font-weight: 700;
  }

  input {
    background: white;
    margin-bottom: 0.75rem;
  }

  p {
    font-family: "Montserrat", sans-serif;
    font-style: italic;
    font-weight: 200;
    font-size: 0.8rem;
    color: ${(props) => props.$textColor || "var(--black)"};
    text-align: start;
  }

  a {
    font-family: "Montserrat", sans-serif;
    font-style: italic;
    font-weight: 200;
    font-size: 0.8rem;
    color: ${(props) => props.$textColor || "var(--black)"};
  }

  h6 {
    text-align: start;
    margin-left: 10px;
    color: ${(props) => props.$textColor || "var(--black)"};
  }

  & > div {
    margin-bottom: 10px;,
  }
`;

export const Title = styled.h2<{ $textColor: string }>`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: ${(props) => props.$textColor || "var(--black)"};
`;

export const Text = styled.p<{ $textColor: string }>`
  font-size: 1rem;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  margin-top: 10px;
  color: ${(props) => props.$textColor || "var(--black)"};
`;
